import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { find } from "lodash";
import { Grid, Box, Tab } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import ActionBar from "./ActionBar";
import UserList from "./UserList";
import { getRolesBySiteUuid } from "./Services";

const UsersPage = (props) => {
  // State
  const [tabValue, setTabValue] = useState(null);
  const [dataForNonTeaching, setDataForNonTeaching] = useState("");
  const [dataForTeaching, setDataForTeaching] = useState("");
  const [dataForLearner, setDataForLearner] = useState("");
  const [clickOption, setClickOption] = useState(null);
  const [selectAllUserFlag, setSelectAllUserFlag] = useState(false);

  // Redux state
  const { paramsdata } = useSelector((state) => state.common);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  

  // React logic hooks
  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
      if(tabValue == null){
        setTabValue('trainer');
      }     
  }, []);

  useEffect(() => {      
      if(paramsdata && paramsdata.tabValue) {
        setTabValue(paramsdata.tabValue);
      }      
}, [paramsdata]);

  const handleChange = (event, newValue) => {    
    setSelectAllUserFlag(false);
    localStorage.removeItem("selectedClassId");
    localStorage.removeItem("selectedClassIds");
    setTabValue(newValue);
  };

  // Fetch roles Data
  const fetchRoles = async () => {    
    let params = {
      query: {
        $select: ["uid", "title"],
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    console.log("resRolesData", resRolesData);
    let nonTeaching = find(resRolesData.data, { title: "staff" });
    let teaching = find(resRolesData.data, { title: "Trainer" });
    let learner = find(resRolesData.data, { title: "learner" });
    //let idForParent = find(resRolesData.data, { 'title': 'parent' });

    setDataForNonTeaching(nonTeaching);
    setDataForTeaching(teaching);
    setDataForLearner(learner);
    //sessionStorage.setItem('userType',tabValue);

  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mx: 6 }}>
        <Box sx={{ width: "100%", typography: "body1", textAlign: "center" }}>          
          <TabContext value={tabValue} sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                borderBottom: 1,
                borderBlockColor: "#EFEFEF",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <TabList
                onChange={handleChange}                
                sx={{ border: "1x solid red" }}
              >
                <Tab
                  label="Trainers"
                  value="trainer"
                  sx={{ textTransform: "inherit", fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
                />
                <Tab
                  label="Learners"
                  value="learner"
                  sx={{ textTransform: "inherit", ml: 15, fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
                />
                <Tab
                  label="Staff"
                  value="staff"
                  sx={{ textTransform: "inherit", ml: 15, fontWeight: '600', color: '#5f5600ff', fontSize: '1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}
                />
              </TabList>
            </Box>
            <TabPanel value="staff">              
              <ActionBar
                rolesData={dataForNonTeaching}
                buttonAction={(val) => {
                  setClickOption(val);
                }}
                userSelectionFlag={selectAllUserFlag}
                userSelectionFlagAction={(val) => {
                  setSelectAllUserFlag(val);
                }}
              />
              <UserList
                rolesData={dataForNonTeaching}
                clickOption={clickOption}
                toggle={() => {
                  setClickOption(null);
                }}
                userSelection={(val) => {
                  setSelectAllUserFlag(val);
                }}
                handleTabValue={(val)=> {handleChange('',val)}}
              />
            </TabPanel>
            <TabPanel value="trainer">              
              <ActionBar
                rolesData={dataForTeaching}
                buttonAction={(val) => {
                  setClickOption(val);
                }}
                userSelectionFlag={selectAllUserFlag}
                userSelectionFlagAction={(val) => {
                  setSelectAllUserFlag(val);
                }}
              />
              <UserList
                rolesData={dataForTeaching}
                clickOption={clickOption}
                toggle={() => {
                  setClickOption(null);
                }}
                userSelection={(val) => {
                  setSelectAllUserFlag(val);
                }}
                handleTabValue={(val)=> {handleChange('',val)}}
              />
            </TabPanel>
            <TabPanel value="learner">              
              <ActionBar
                rolesData={dataForLearner}
                buttonAction={(val) => {
                  setClickOption(val);
                }}
                userSelectionFlag={selectAllUserFlag}
                userSelectionFlagAction={(val) => {
                  setSelectAllUserFlag(val);
                }}
              />
              <UserList
                rolesData={dataForLearner}
                clickOption={clickOption}
                toggle={() => {
                  setClickOption(null);
                }}
                userSelection={(val) => {
                  setSelectAllUserFlag(val);
                }}
                handleTabValue={(val)=> {handleChange('',val)}}
              />
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default UsersPage;
